<template>
    <b-modal ref="modal" centered :title="(formData != null) ? `${formData.flow}, ${formData.client}, ${formData.address}` : ''" @close="$emit('close')" no-close-on-backdrop no-close-on-esc hide-footer>
        <div class="d-block mt-2">
          <div role="group" class="b-form-group form-group" v-if="formData != null">
              <div class="form-row mb-lg">
                <div class="col-sm-12">
                    <table class="table table-responsive table-striped">
                        <thead>
                        <tr>
                            <th>{{$t('STEP')}}</th>
                            <th>{{$t('QUESTION')}}</th>
                            <th>{{$t('ANSWER')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="item in response.root">
                            <tr :key="item.jobAnswerId" aria-rowindex="1" class=" table-ellipsis">
                                <td>{{item.name}}</td>
                                <td>{{item.label}}</td>
                                <td>{{item.answer}}</td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
              </div>
          </div>

          <div class="text-right">
              <b-btn class="mr-2 button-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
          </div>

          </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/job/JobAnswer.js';


export default
{
    name: 'StepButtonsForm',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            response: {},
            formError: {},
            formData: null,
            buildingDetailPagination: {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
        };
    },
    methods:
    {
        async getData(jobId)
        {
            const me = this;
            try
            {
                const data = await Api.selectRow({jobId: jobId});
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.response = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        close()
        {
            const me = this;
            me.response = null;
            me.formData = null;
            me.formError = {};
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                await me.getData(val.jobId);
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
};
</script>
